
import { inAppRedirect } from '~/utils/route-redirects';

export default {
  name: 'NotificationPortfolioLike',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToTarget(targetId) {
      inAppRedirect(`/portfolios/${targetId}`);
    },
  },
};
